import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForProductFamilyComponent extends Component {
  // Defaults
  defaultColumns = [
    'id',
    'headline',
    'contributors',
    'cmsState',
    'cmsModified',
  ];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'headline',
      sortable: true,
      isMainColumn: true,
    },
    {
      property: 'contributors',
      relationPath: 'artist',
      relationLabel: 'artist.displayLabel',
      type: 'relation',
    },
    {
      property: 'cmsState',
      sortable: true,
      type: 'translate-value',
      align: 'right',
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];
}
